import React from "react";

import { FormSingleSelect, Text } from "@performyard/py-components";

import { GridCol } from "../../../../../components/Grid";
import Spacer from "../../../../../components/Spacer";

type GoalFrameworkSelectProps = {
	id: string;
	dataTestId?: string;
	label: string;
	description: string;
	options: { value: string; label: string }[];
};

export const GoalFrameworkSelect = ({ id, dataTestId, label, description, options }: GoalFrameworkSelectProps) => {
	return (
		<GridCol span={5}>
			<FormSingleSelect<string>
				id={id}
				data-testid={dataTestId}
				labelPosition="left"
				justify="between"
				disableLabelClick
				dangerouslySetClassName="!w-auto flex-shrink ml-auto min-w-[197px]"
				label={
					<div className="min-w-0 flex-shrink">
						<Text size="paragraph-2" weight="semi-bold" color="neutral-9">
							{label}
						</Text>
						<Spacer height={1} />
						<div className="max-w-[300px]">
							<Text size="paragraph-3" weight="regular" color="neutral-9">
								{description}
							</Text>
						</div>
					</div>
				}
				options={options}
			/>
		</GridCol>
	);
};
